import React from "react";
import PropTypes from "prop-types";
import { Wrapper } from "../../constants/common/StyledGlobalConstants";

const SkeletonLoader = ({ isLoading, windowSizeWidth }) => {
  return (
    <>
      {isLoading ? (
          <Wrapper display="grid" padding="16px 8px" gap="8px">
            <Wrapper display="grid" gap="8px" gridTemplateColumns={windowSizeWidth < 481 ? "25% 22%" : "14% 11%"}>
              <Wrapper gridRow={1} gridColumn={1} className="skeleton" backgroundColor="#F2F2f2" height="1.5rem"></Wrapper>
              <Wrapper gridRow={1} gridColumn={2} className="skeleton" backgroundColor="#F2F2f2" height="1.5rem"></Wrapper>
            </Wrapper>
            <Wrapper display="grid" gridTemplateColumns="91%">
              <Wrapper gridRow={1} className="skeleton" backgroundColor="#F2F2f2" height="1.5rem"></Wrapper>
            </Wrapper>
            <Wrapper display="grid" gridTemplateColumns={windowSizeWidth < 481 ? "65%" : "48%"}>
              <Wrapper gridRow={1} className="skeleton" backgroundColor="#F2F2f2" height="1.5rem"></Wrapper>
            </Wrapper>
          </Wrapper>
      ) : null}
    </>
  );
};

SkeletonLoader.defaultProps = {
  isLoading: false,
};

SkeletonLoader.propTypes = {
  isLoading: PropTypes.bool,
  windowSizeWidth: PropTypes.number.isRequired,
};

export default SkeletonLoader;
